import styled from '@emotion/styled'
import { isMobile } from '@const/device'

export const FilterPanelWrapper = styled.div`
  display: flex;
  padding: ${() => (isMobile ? '0 5px' : '10px 20px 0')};
`
